<div class="permission-text">
  <h4 class="section-hdr daily-export" l10nTranslate>shared.dailyExportLimitsForDifferentEntities</h4>
</div>
<table aria-hidden="true" cdk-table [dataSource]="exportLimitsDataSource" class="exportslimit">
  <ng-container cdkColumnDef="availability">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.availability</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.availability }}</td>
  </ng-container>
  <ng-container cdkColumnDef="lease">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.leaseComps</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.lease }}</td>
  </ng-container>
  <ng-container cdkColumnDef="sale">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.saleComps</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.sale }}</td>
  </ng-container>
  <ng-container cdkColumnDef="portfoliosale">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>
      shared.portfoliosaleComps
    </th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.portfoliosale }}</td>
  </ng-container>
  <ng-container cdkColumnDef="property">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.property</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.property }}</td>
  </ng-container>
  <ng-container cdkColumnDef="tim">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.tim</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.tim }}</td>
  </ng-container>
  <ng-container cdkColumnDef="company">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.company</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.company }}</td>
  </ng-container>
  <ng-container cdkColumnDef="contact">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.contact</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.contact }}</td>
  </ng-container>
  <ng-container cdkColumnDef="tenancy">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.tenancy</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.tenancy }}</td>
  </ng-container>
  <ng-container cdkColumnDef="brand">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.brand</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.brand }}</td>
  </ng-container>
  <ng-container cdkColumnDef="stackingplan">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.stackingPlans</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.stackingplan }}</td>
  </ng-container>
  <ng-container cdkColumnDef="actions">
    <th scope="col" class="twelve-grid--1-12" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let exportLimit">
      <button mat-icon-button class="submit-btn" (click)="openEditDialog()" *ngIf="!isReadyOnly">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
</table>
